// @flow

import type { PropsSchema, EasyAction, BasicProps } from '../../type'

import * as React from 'react'
import PropTypes from 'prop-types'
import {
  getFormValues,
  setFormValues,
  coverFormValues,
  getFormValidateRules
} from '../../redux/basic'
import computeData from '../hoc/computeData'
import { validateForm } from 'frame/core/formValidate'

type Props = BasicProps & {
  id: string,
  style: { [string]: string },
  children: React.ChildrenArray<React.Node>,
  initFormCode: string,
  formDataCode: string
};

@computeData()
export default class Folder extends React.PureComponent<Props> {
  static schema: PropsSchema = [
    {
      key: 'initFormCode',
      type: 'code',
      title: '初始化表单内容'
    },
    {
      key: 'formDataCode',
      type: 'code',
      title: '表单数据处理'
    },
    'separator',
    {
      type: 'event',
      title: '校验成功',
      event: 'resolve'
    },
    {
      type: 'event',
      title: '校验失败',
      event: 'reject'
    }
  ];

  static actions: EasyAction[] = [
    {
      title: '数据绑定',
      name: 'bindData',
      dataSchema: [
        {
          key: 'type',
          title: '类型',
          type: 'select',
          required: true,
          defaultValue: 'merge',
          options: [['merge', '合并'], ['cover', '覆盖']]
        }
      ]
    },
    {
      title: '表单校验',
      name: 'formValidate',
      dataSchema: [
        {
          key: 'exclude',
          title: '排除字段'
        }
      ]
    }
  ];

  static childContextTypes = {
    formId: PropTypes.string
  };

  constructor (props: Props) {
    super(props)
    let formValues = {}
    const { id, jsEnv, initFormCode } = this.props
    if (initFormCode) {
      formValues = jsEnv.runCode(initFormCode)
    }
    setFormValues(id, formValues)
  }

  getChildContext () {
    return {
      formId: this.props.id
    }
  }

  actionBindData = (data: { type?: string } = {}, formValues: {}) => {
    const { type = 'merge' } = data
    const { jsEnv, formDataCode, id } = this.props
    if (formDataCode) {
      formValues = jsEnv.runCodeWithAdditionalCtx(formDataCode, formValues)
    }
    if (type === 'merge') {
      setFormValues(id, formValues)
    } else if (type === 'cover') {
      coverFormValues(id, formValues)
    }
  };

  actionFormValidate = (data: { exclude?: string } = {}) => {
    const { exclude = '' } = data
    const { id, callActions } = this.props
    const fieldRules = getFormValidateRules(id)
    if (fieldRules) {
      let fromValue = getFormValues(id)
      if (fromValue) {
        fromValue = fromValue.toJS()
      }
      const excludeArray = exclude.split(',')
      const messages = validateForm(fromValue, fieldRules, excludeArray)
      const { message, success, messageArray } = messages
      if (success) {
        callActions('resolve')
      } else {
        callActions('reject', { ...(message || {}), messageArray })
      }
    }
  };

  render () {
    if (!this.props.visible) {
      return null
    }
    const { id, children } = this.props
    return (
      <form id={id} ref='form'>
        {children}
      </form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/form/Form.js